import { useRef, useMemo } from 'react';
import { useFrame } from '@react-three/fiber';
const COUNT = 1800;

export default function Starfield() {
  const ref = useRef();

  const [positions, colors] = useMemo(() => {
    const pos = new Float32Array(COUNT * 3);
    const col = new Float32Array(COUNT * 3);

    for (let i = 0; i < COUNT; i++) {
      const i3 = i * 3;
      pos[i3]     = (Math.random() - 0.5) * 80;
      pos[i3 + 1] = (Math.random() - 0.5) * 50;
      pos[i3 + 2] = Math.random() * -60 - 2;

      // 70% red, 30% white
      const isRed = Math.random() > 0.3;
      col[i3]     = isRed ? 1 : 0.8;
      col[i3 + 1] = isRed ? 0 : 0.8;
      col[i3 + 2] = isRed ? 0 : 0.8;
    }
    return [pos, col];
  }, []);

  useFrame((_, delta) => {
    if (!ref.current) return;
    ref.current.rotation.z += delta * 0.008;
  });

  return (
    <points ref={ref}>
      <bufferGeometry>
        <bufferAttribute attach="attributes-position" args={[positions, 3]} />
        <bufferAttribute attach="attributes-color" args={[colors, 3]} />
      </bufferGeometry>
      <pointsMaterial
        size={0.08}
        vertexColors
        transparent
        opacity={0.85}
        sizeAttenuation
        depthWrite={false}
      />
    </points>
  );
}
